import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
//import { ViewContainersService } from '@urbannex/view-containers';
import { ViewCell } from '../ofbiz-form-model';

@Component({
  template: `
    <div class="hyperlink" (click)="emit($event)">
      <span>
        <img src="assets/images/icons/outline/file-outline.svg" class="custom-icon hungry">
      </span>
    {{renderValue}}
    </div>
  `,
})
export class OfbizCellHyperLinkComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;
  @Input() column:any;
  @Input() field:any;
  selectedValue:any;
  @Output() cellHyperlinkSelected = new EventEmitter();

  constructor() { }
  
  ngOnInit() {
    console.log({TrackRenderComponent:{Component:"OfbizCellHyperLinkComponent",RowData:this.rowData}});
    console.log(this.value);
    console.log(this.column)
    this.renderValue = this.value.toString();
    this.makeSelectedValue();
  }

  makeSelectedValue(){
    return this.selectedValue = {
      event:this.field.event, //Event can be view,list,add or edit
      type:this.field.formData.formName, //Type is formName/ListName/View
      label:"", //Text value to be used in headers/breadCrumbs etc.
      data:{
        formData:{
          formName:this.field.formData.formName,
          formLocation:this.field.formData.formLocation,
          listType:this.field.formData.listType,
          link:this.formatLink(this.field.formData.link,this.makeParameterMap(this.rowData,this.field)),
          entityName:"",
          viewIndex:1
        },
        endPoint:"string",
        appContext:"",
        parameters:this.makeParameterMap(this.rowData,this.field)
      }
    }
  }

  emit(e){
    console.log("HyperLink Clicked - this is the data: ",this.rowData)
    this.cellHyperlinkSelected.emit(this.selectedValue);
    //this.viewContainerService.setSelectedRow(this.rowData);
  }

  formatLink(rawLink:string,parameterMaps:any):string{
    console.log({rawLink:rawLink,parameterMaps:parameterMaps});
    let link = "";
    if(this.containsDollarBracketVariable(rawLink)){
      link = this.replaceDollarBracketVariable(rawLink,parameterMaps);
    }
    return link
  }

  makeParameterMap(rowData,field){
    let parameters = {};
    if(rowData["parameterMaps"] != undefined && rowData["parameterMaps"].length > 0){
      let parameterMaps:any [] = rowData["parameterMaps"];
      let parameterMap = parameterMaps.find(element => element.fieldName == field.name);
      if(parameterMap != undefined){
        //console.log({parameterMapFromRowData:parameterMap});
        parameters = parameterMap["parameterMap"];
      }else{
        parameterMap = parameterMaps[0];
        parameters = parameterMap["parameterMap"];
      }
    }
    console.log("makeParameterMap",parameters)
    return parameters
  }

  containsDollarBracketVariable(str: string): boolean {
    const regex = /\${(.*?)}/;
    return regex.test(str);
  }

  replaceDollarBracketVariable(str: string, variables: { [key: string]: string }): string {
    return str.replace(/\${(.*?)}/g, (match, p1) => {
        return variables[p1] || '';
    });
  }

}
